import { useState, useEffect, useRef } from "react";
import { AddLayout } from "../../../layouts";
/* import { parse } from "date-fns"; */
import {
  TextareaAutosize,
  Autocomplete,
  Select,
  Switch,
  FormControlLabel,
  MenuItem,
  Button,
  InputAdornment,
  IconButton,
  Box,
  Grid,
  TextField,
  ImageCropper,
  MaskedInput,
  Form,
  DatePicker,
  Tooltip,
  //TextFieldNumber,
} from "../../../components";
import {
  PessoaService,
  SessionService,
  notification,
  history,
  ReceitaCnpjCpfService,
  StorageService,
  TiposPessoasService,
  ConfiguracoesService,
  EnderecoService,
  ColaboradorService,
  TagsService,
  RotaService,
  SegmentoService,
} from "../../../services";
import "./pessoa.css";
import { Enderecos, MenuAddActions, TipoPessoas } from "./components";
import {
  dataURLtoFile,
  userLogs,
  responseErros,
  formatDate,
  voltar,
  cacheApi,
} from "../../../utils";
import {
  pessoaValidator,
  clienteValidator,
  fornecedorValidator,
  transportadoraValidator,
  prestadorServicoValidator,
  profissionalValidator,
  colaboradorValidator,
  enderecoValidator,
} from "./middlewares";
import {
  value,
  ValidarCpfCnpjHelper,
  InputErros,
  PermisoesHelper,
} from "../../../helpers";
import shortid from "shortid";
import { setInputValuePessoa } from "./addPessoa";
import { useImportContext } from "../../../contexts/import.context";
import { Pessoa } from "../entities/pessoa.entity";
//import { filtrosUrl } from "../../../helpers";
import { useCacheContext } from "../../../contexts/cache.context";
const notFoundImage = "https://public.siafevolution.com.br/not-found.png";
const TIPO_PESSOA_COLABORADOR = 4;

const sessionService = new SessionService();
const pessoaService = new PessoaService();
const tiposPessoasService = new TiposPessoasService();
const receitaCnpjCpfService = new ReceitaCnpjCpfService();
const enderecoService = new EnderecoService();
const validarCpfCnpjHelper = new ValidarCpfCnpjHelper();
const storageService = new StorageService();
const colaboradorService = new ColaboradorService();
const configuracoesService = new ConfiguracoesService();
const tagsService = new TagsService();
const rotaService = new RotaService();
const segmentoService = new SegmentoService();

const AddPessoas = ({
  match,
  isFullscreenDialog,
  onChangeCliente,
  handleCloseFullscreenDialog,
}) => {
  const { id } = match.params;
  const { initialCollapses } = useImportContext();
  const { cacheDto, setCacheDto } = useCacheContext();
  const imageUpload = useRef();
  const clienteFormRef = useRef(null);
  const fornecedorFormRef = useRef(null);
  const transportadoraFormRef = useRef(null);
  const colaboradorFormRef = useRef(null);
  const prestadorServicoFormRef = useRef(null);
  const profissionalFormRef = useRef(null);
  const [permisoes, setPermisoes] = useState({});
  const [obrigadoriedadeCnpjCpf, setObrigatoriedadeCnpjCpf] = useState(false);
  const [pessoa, setPessoa] = useState({});
  // const prevStateRef = useRef(pessoa);
  const [cliente, setCliente] = useState({
    indicadorConsumidorFinal: false,
    tipoContribuinteId: 3,
  });
  const [fornecedor, setFornecedor] = useState({});
  const [transportadora, setTransportadora] = useState({});
  const [colaborador, setColaborador] = useState({
    vendedor: false,
  });
  const [prestadorServico, setPrestadorServico] = useState({});
  const [profissional, setProfissional] = useState({});
  const [enderecosLista, setEnderecosLista] = useState([]);
  const [inputErro, setInputErro] = useState([]);
  const inputErros = new InputErros(inputErro, setInputErro);
  const [isCropping, setIsCropping] = useState(false);
  const [imageAvatar, setImageAvatar] = useState(null);
  const [listaTiposPessoa, setListaTiposPessoa] = useState([]);
  const [listaTags, setListaTags] = useState([]);
  const [listaRotas, setListaRotas] = useState([]);
  const [listaSegmentos, setListaSegmentos] = useState([]);
  const [userLog, setUserLog] = useState({});
  const [loading, setLoading] = useState(false);
  const [abaValue, setAbaValue] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openEndereco, setOpenEndereco] = useState(false);
  const [inputErroEndereco, setInputErroEndereco] = useState([]);
  const inputErrosEnderecos = new InputErros(
    inputErroEndereco,
    setInputErroEndereco,
  );
  const [buscaCnpjRealizada, setBuscaCnpjRealizada] = useState(false);
  const permissoesHelper = new PermisoesHelper();
  permissoesHelper.validarPermisao("pessoas-visualizar");
  const pessoaValidatorService = pessoaValidator(obrigadoriedadeCnpjCpf);
  const isMenuOpen = Boolean(anchorEl);
  const menuId = "primary-add-actions-menu";

  const tiposPessoasAbaAtiva = {
    fornecedor: 1,
    transportadora: 2,
    colaborador: 3,
    "prestador de serviço": 4,
    profissional: 5,
  };

  async function buscarDadosIniciais() {
    await buscaPessoa();
    buscaConfiguracoes();
    buscarTags();
    buscaRotas();
    buscaSegmentos();
    buscaPermisoes();
    buscaTipoPessoa();
  }

  useEffect(() => {
    buscarDadosIniciais();
  }, []);

  async function onClickLog() {
    if ("userCreatedLog" in userLog) return;
    const logs = await userLogs(pessoa);
    setUserLog(logs);
  }

  function buscaPermisoes() {
    const permisoes = sessionService.getPermisoes();
    if (permisoes) {
      setPermisoes(permisoes);
    }
  }

  async function buscaConfiguracoes() {
    if (id) return;
    const configuracoes = await configuracoesService.get();
    if (configuracoes.data?.count) {
      setObrigatoriedadeCnpjCpf(
        configuracoes.data.rows[0].obrigatoriedadeCnpjCpf,
      );
    }
  }

  const buscaTipoPessoa = async () => {
    const cacheBody = {
      timeMinutes: 60,
      apiFunction: tiposPessoasService.getAll(),
      dto: { cacheDto, setCacheDto },
    };
    const res = await cacheApi(tiposPessoasService.urlBase, cacheBody);
    if (!res.isAxiosError) {
      const filterCredenciadora = res.data.filter(
        (objeto) => objeto.descricao !== "Credenciadora",
      );
      setListaTiposPessoa(filterCredenciadora);
    }
  };

  const buscaPessoa = async () => {
    if (!id) {
      return setPessoa({
        ativado: true,
        naturezaSocial: "fisica",
      });
    }
    setLoading(true);
    pessoaService.getById(id).then((res) => {
      if (!res.isAxiosError) {
        if (!res.data) {
          initialCollapses();
          voltar();
          return;
        }
        if (res.data.cnpjCpf === "") {
          delete res.data.cnpjCpf;
        }
        adicionarTiposPessoas(res.data);
        setPessoa(res.data);
        setInputValuePessoa(res.data);
        abaValueAtiva(res.data?.tiposPessoas[0]?.descricao.toLowerCase());
        inserirValoresListaTags(res.data?.tagsPessoa);
      } else {
        responseErros(res);
        initialCollapses();
        voltar();
      }
      setLoading(false);
    });
  };

  function inserirValoresListaTags(listaTagsIds) {
    const idsTags =
      listaTagsIds?.map((tags) => ({
        id: tags.tagId,
      })) || [];
    setPessoa((prevState) => ({
      ...prevState,
      ...pessoa,
      tagsPessoa: idsTags,
    }));
  }

  const abaValueAtiva = (tiposPessoas) => {
    setAbaValue(tiposPessoasAbaAtiva[tiposPessoas] || 0);
  };

  const adicionarTiposPessoas = (pessoa) => {
    let dataCliente = {};
    if (pessoa?.clientes?.length) {
      const data = pessoa?.clientes?.length ? pessoa.clientes[0] : {};
      const meiosPagamento = data.meiosPagamento.map(({ meioPagamentoId }) => ({
        id: meioPagamentoId,
      }));
      const marcas = data.marcas.map(({ marcaId }) => ({
        id: marcaId,
      }));
      const grades = data.grades.map(({ variacaoGradeId }) => ({
        id: variacaoGradeId,
      }));
      dataCliente = { ...data, meiosPagamento, marcas, grades };
    }
    setCliente(dataCliente);
    const dataFornecedor = pessoa?.fornecedores?.length
      ? pessoa.fornecedores[0]
      : {};
    setFornecedor(dataFornecedor);
    const dataTransportadora = pessoa?.transportadoras?.length
      ? pessoa.transportadoras[0]
      : {};
    setTransportadora(dataTransportadora);
    const dataColaborador = pessoa?.colaboradores?.length
      ? pessoa.colaboradores[0]
      : {};
    setColaborador(dataColaborador);
    const dataPrestadorServico = pessoa?.prestadorSevico?.length
      ? pessoa.prestadorSevico[0]
      : {};
    setPrestadorServico(dataPrestadorServico);
    const dataProfissional = pessoa?.profissionais?.length
      ? pessoa.profissionais[0]
      : {};
    setProfissional(dataProfissional);
  };

  const buscarTags = () => {
    const filter = {
      nonPaginated: true,
      ativado: true,
      tipo: "PESSOA",
    };
    tagsService.getAll(filter).then((res) => {
      if (!res.isAxiosError) {
        setListaTags(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const buscaRotas = () => {
    const filter = {
      nonPaginated: true,
    };
    rotaService.getAll(filter).then((res) => {
      if (!res.isAxiosError) {
        setListaRotas(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const buscaSegmentos = () => {
    const filter = {
      nonPaginated: true,
    };
    segmentoService.getAll(filter).then((res) => {
      if (!res.isAxiosError) {
        setListaSegmentos(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const handleInputChange = (event, limiteChar = null) => {
    const name = event.target.name;
    let value = event.target.value;
    const pessoasTemp = {
      ...pessoa,
      [name]: value || "",
    };
    if (name === "sexo" && !value) {
      pessoasTemp[name] = value;
    }
    handleChangeInscricao(pessoasTemp, name, value);
    if (limiteChar) {
      let valor = value;
      if (valor.length <= limiteChar) {
        pessoasTemp[name] = value;
      } else {
        return;
      }
    }
    setPessoa(pessoasTemp);
  };

  function handleChangeInscricao(pessoasTemp, name, value) {
    const isInscricao = name.includes("inscricao");
    if (!isInscricao) return pessoasTemp;
    pessoasTemp[name] = value?.replace(/[^0-9./-]/g, "");
    if (name !== "inscricaoSuframa") {
      const originalName =
        name === "inscricaoEstadual"
          ? "inscricaoEstadual2"
          : "inscricaoEstadualRural2";
      if (!pessoasTemp[name]) pessoasTemp[originalName] = "";
    }
  }

  const handleDateChange = (prop, date) => {
    if (!date) {
      date = "Invalid Date";
    }
    setPessoa({
      ...pessoa,
      [prop]: date != "Invalid Date" ? formatDate.toSend(date) : null,
    });
  };

  const buscarCpfCnpjRepetido = async (cnpjCpf, naturezaSocial) => {
    let data = null;
    if (id) {
      const res = await pessoaService.getAllFiltroAvancado({
        id: `~neq~${id}`,
        cnpjCpf,
        restritiva: true,
      });
      if (!res.isAxiosError) {
        data = res.data;
      }
    } else {
      const res = await pessoaService.getAllFiltroAvancado({
        cnpjCpf,
        restritiva: true,
      });
      if (!res.isAxiosError) {
        data = res.data;
      }
    }
    if (data && data.rows.length > 0) {
      const pessoa = data.rows[0];
      if (naturezaSocial == "fisica") {
        inputErros.gerar("cnpjCpf");
        throw new Error(
          `CPF já cadastrado para: ${
            pessoa.codigo
          } - ${pessoa.nomeRazaoSocial.slice(0, 24)}...`,
        );
      } else {
        inputErros.gerar("cnpjCpf");
        throw new Error(
          `CNPJ já cadastrado para: ${
            pessoa.codigo
          } - ${pessoa.nomeRazaoSocial.slice(0, 24)}...`,
        );
      }
    }
  };

  async function verificarDocumento(cnpjCpf, naturezaSocial) {
    const pessoaFisica = naturezaSocial == "fisica";
    const documentoValido = pessoaFisica
      ? validarCpfCnpjHelper.cpf(cnpjCpf, obrigadoriedadeCnpjCpf)
      : validarCpfCnpjHelper.cnpj(cnpjCpf, obrigadoriedadeCnpjCpf);
    if (!documentoValido) {
      inputErros.gerar("cnpjCpf");
      throw new Error(`${pessoaFisica ? "CPF" : "CNPJ"} inválido`);
    }
    return await verificarDocumentoRepetido(cnpjCpf, naturezaSocial);
  }

  async function validarUsuarioVendedor(dados) {
    const filtro = {
      nonPaginated: true,
      vendedor: true,
    };
    const { usuarioId, bancoCaixaId } = dados.colaborador;
    if (!usuarioId && !bancoCaixaId) return;
    await colaboradorService.getAll(filtro).then((result) => {
      if (!result.isAxiosError) {
        const colaboradorVendedorUsuario = result.data.find(
          (colaborador) => colaborador.usuarioId === usuarioId,
        );
        if (
          colaboradorVendedorUsuario?.usuarioId &&
          colaboradorVendedorUsuario.pessoa.id !== Number(id)
        ) {
          inputErros.gerar("usuarioId");
          throw new Error("Usuário já vinculado a um colaborador");
        }
        const colaboradorVendedorBanco = result.data.find(
          (colaborador) => colaborador.bancoCaixaId === bancoCaixaId,
        );
        if (
          colaboradorVendedorBanco?.bancoCaixaId &&
          colaboradorVendedorBanco.pessoa.id !== Number(id)
        ) {
          inputErros.gerar("bancoCaixaId");
          throw new Error("Caixa já vinculado a um colaborador");
        }
      } else {
        responseErros(result);
      }
    });
  }

  async function verificarDocumentoRepetido(cnpjCpf, naturezaSocial) {
    if (cnpjCpf) {
      await buscarCpfCnpjRepetido(cnpjCpf, naturezaSocial);
    }
  }

  async function verificarTiposPessoa(pessoaForm) {
    if (pessoaForm.tiposPessoas.length) {
      for (const tipo of pessoaForm.tiposPessoas) {
        const isTipoPessoaValid = await validateTiposPessoa(
          tipo.id,
          pessoaForm,
        );
        if (!isTipoPessoaValid) {
          throw new Error(
            `Preencha o(s) campo(s) obrigatório(s) da aba ${tipo.descricao}`,
          );
        }
      }
    }
  }

  const verificarImagemPessoa = async (pessoaForm) => {
    if (!imageAvatar) {
      return pessoaForm?.imagemOriginal;
    }
    if (pessoaForm.imagemOriginal) {
      await storageService.removeImage(pessoaForm.imagemOriginal);
    }
    const formData = new FormData();
    formData.append("image", imageAvatar);
    const resStorage = await storageService.addImage(formData);
    pessoaForm.avatar = !resStorage.isAxiosError
      ? resStorage.data.fileName
      : pessoaForm.avatar;
    pessoa.imagemOriginal = pessoaForm.avatar;
    return pessoa.imagemOriginal || pessoaForm.avatar;
  };

  const montaObjetoPessoa = (body) => {
    const bodyTemp = Number.isFinite(body) ? obterValoresDoFormulario() : body;
    const dadosPessoa = new Pessoa(
      bodyTemp,
      pessoa,
      cliente,
      fornecedor,
      transportadora,
      colaborador,
      prestadorServico,
      profissional,
    );
    dadosPessoa.setCnpjCpf(id, pessoa, bodyTemp);
    dadosPessoa.setPessoaTagsIds(pessoa.tagsPessoa);
    dadosPessoa.setInformacoesBuscaCnpj(buscaCnpjRealizada, pessoa);
    dadosPessoa.cliente.setClienteMeiosPagamentoIds(cliente.meiosPagamento);
    return dadosPessoa;
  };

  const handleSubmit = (body) => {
    const dadosPessoa = montaObjetoPessoa(body);
    pessoaValidatorService
      .validate(dadosPessoa, { abortEarly: false })
      .then(async () => {
        const dataError = Array.isArray(inputErro)
          ? inputErro.find(
              (erro) =>
                erro.includes("Data de Abertura") ||
                erro.includes("Data de Nascimento"),
            )
          : undefined;

        if (dataError) {
          return notification.alertaGenericos(`${dataError} Inválida`);
        }
        const avatar = await verificarImagemPessoa(dadosPessoa);
        dadosPessoa.setAvatar(avatar);
        try {
          await verificarTiposPessoa(dadosPessoa);
          if (pessoa.cnpjCpf !== dadosPessoa.cnpjCpf) {
            await verificarDocumento(
              dadosPessoa.cnpjCpf,
              dadosPessoa.naturezaSocial,
            );
          }
          if (dadosPessoa.idTiposPessoa.includes(4)) {
            await validarUsuarioVendedor(dadosPessoa);
          }
        } catch (error) {
          return notification.alertaGenericos(error.message);
        }
        setLoading(true);
        if (id) {
          atualizarPessoa(dadosPessoa);
        } else {
          cadastrarPessoa(dadosPessoa, body);
        }
      })
      .catch((err) => {
        inputErros.set(err);
        retornoElemento(err?.inner?.length ? err?.inner[0]?.params.path : "");
      });
  };

  const validateTiposPessoa = async (tipo, body) => {
    switch (tipo) {
      case 1:
        return validate(clienteValidator, body.cliente, inputErros);
      case 2:
        return validate(fornecedorValidator, body.fornecedor, inputErros);
      case 3:
        return validate(
          transportadoraValidator,
          body.transportadora,
          inputErros,
          true,
        );
      case 4:
        return validate(colaboradorValidator, body.colaborador, inputErros);
      case 5:
        return validate(
          prestadorServicoValidator,
          body.prestadorServico,
          inputErros,
        );
      case 6:
        return validate(profissionalValidator, body.profissional, inputErros);
      default:
        return true;
    }
  };

  const validateEnderecos = () => {
    if (!enderecosLista.length) {
      validate(enderecoValidator, {}, inputErrosEnderecos);
      setOpenEndereco(true);
      return false;
    }
    return true;
  };

  const validate = (schema, objeto, inputErros, validaEnderecos) => {
    if (validaEnderecos && !validateEnderecos()) return;
    return schema
      .validate(objeto, { abortEarly: false })
      .then(() => {
        return true;
      })
      .catch((err) => {
        inputErros.set(err);
        retornoElemento(err?.inner?.length ? err?.inner[0]?.params.path : "");
        return false;
      });
  };

  const cadastrarPessoa = async (body, indiceSelecionado) => {
    if (enderecosLista.length) {
      body.enderecos = enderecosLista.map((endereco) => {
        delete endereco.id;
        return endereco;
      });
    }
    const res = await pessoaService.cadastrar(body);
    setLoading(false);
    if (!res.isAxiosError) {
      notification.cadastroSucesso();
      if (!Number.isInteger(indiceSelecionado)) {
        if (isFullscreenDialog) {
          if (onChangeCliente && res.data?.id) {
            onChangeCliente(res.data);
          }
          return handleCloseFullscreenDialog();
        }
        history.goBack();
      } else if (indiceSelecionado === 1) {
        location.reload();
      }
    } else {
      responseErros(res);
    }
  };

  const atualizarPessoa = async (body) => {
    const res = await pessoaService.atualizar(id, body);
    setLoading(false);
    if (!res.isAxiosError) {
      notification.alteracaoSucesso();
      history.goBack();
    } else {
      responseErros(res);
    }
  };

  const handleAddImage = () => {
    imageUpload.current.click();
  };

  const handleEditImage = () => {
    setImageAvatar(pessoa.avatar);
    setIsCropping(true);
  };

  const handleRemoveImage = () => {
    setPessoa({
      ...pessoa,
      avatar: null,
    });
    setImageAvatar(null);
  };

  const handleAvatarChange = (event) => {
    const file =
      event.target.files[0] ||
      (event.dataTransfer && event.dataTransfer.files[0]);
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => {
      setImageAvatar(reader.result);
      setIsCropping(true);
    };
    reader.readAsDataURL(file);
  };

  const onSaveImageClopper = (croppedFile) => {
    setIsCropping(false);
    const file = dataURLtoFile(croppedFile, "avatar");
    setImageAvatar(file);
    setPessoa({
      ...pessoa,
      avatar: croppedFile,
    });
  };

  const onHideImageCropper = () => {
    setImageAvatar(null);
    setIsCropping(false);
  };

  const onClickPesquisarCpfCnpj = async () => {
    const cnpjCpf = document.getElementById("cnpjCpf");
    const doc = cnpjCpf.value.replace(/\D+/g, "");
    if (!cnpjCpf.value) {
      inputErros.gerar("cnpjCpf", "Cnpj");
      return notification.alertaGenericos(`Cnpj é obrigatório para pesquisa`);
    }
    if (/[A-Z]/i.test(cnpjCpf.value)) {
      return notification.alertaGenericos(
        "A consulta automática na Receita não está disponível para CNPJ alfanumérico. Por favor, preencha os dados manualmente.",
      );
    }
    if (!pessoa?.naturezaSocial) {
      return inputErros.gerar("naturezaSocial", "Natureza Social");
    }
    try {
      await verificarDocumento(doc, pessoa.naturezaSocial);
    } catch (error) {
      return notification.alertaGenericos(error.message);
    }
    inputErros.set(null);
    const result = await receitaCnpjCpfService.buscarCnpj(doc);
    if (!result.isAxiosError) {
      setBuscaCnpjRealizada(true);
      setPessoa((prevState) => ({
        ...prevState,
        cnpjCpf: doc,
        nomeRazaoSocial: result.data?.razao_social,
        apelidoFantasia: result.data?.nome_fantasia,
        dataAbertura: formatDate.toSend(
          new Date(result.data?.data_inicio_atividade),
        ),
        email: result.data?.email,
      }));
      if (result.data?.cep) {
        const enderecoData = await enderecoService.getByCep(result.data?.cep);
        if (!enderecoData.isAxiosError) {
          setEnderecosLista([
            {
              id: shortid.generate(),
              cep: result.data?.cep,
              bairro: enderecoData.data?.bairro,
              logradouro: enderecoData.data?.logradouro,
              cidade: enderecoData.data?.nome,
              estado: enderecoData.data.estado?.sigla,
              estadoId: enderecoData.data.estado?.id,
              numero: result.data?.numero,
              descricao: result.data?.descricao_tipo_de_logradouro,
              cidadeId: enderecoData.data?.id,
              exterior: false,
            },
          ]);
        } else responseErros(enderecoData);
      }
    } else responseErros(result);
  };

  const possuiInformacoesColaborador = () =>
    Boolean(
      colaborador?.vendedor ||
        colaborador?.motorista ||
        colaborador?.bancoCaixaId ||
        colaborador?.usuarioId,
    );

  const handleChangeTiposPessoas = async (tiposPessoasSelecionados) => {
    const tiposPessoasAtuais = pessoa?.tiposPessoas ?? [];
    const removeuColaborador =
      tiposPessoasAtuais.some((tipo) => tipo.id === TIPO_PESSOA_COLABORADOR) &&
      !tiposPessoasSelecionados.some(
        (tipo) => tipo.id === TIPO_PESSOA_COLABORADOR,
      );
    if (removeuColaborador) {
      if (possuiInformacoesColaborador()) {
        const retornoAlerta = await notification.confirmacaoGenericos({
          title: "Excluir!",
          text: "Essa pessoa possui informações de vendedor. Ao remover esse tipo de pessoa, os dados serão excluídos. Deseja continuar?",
          icon: "warning",
          confirmButtonText: "EXCLUIR",
          cancelButtonText: "CANCELAR",
          showCancelButton: true,
        });
        if (!retornoAlerta.isConfirmed) return;
      }
      setColaborador({
        id: colaborador?.id,
        vendedor: false,
      });
    }
    setPessoa({
      ...pessoa,
      tiposPessoas: tiposPessoasSelecionados,
    });
  };

  const getMultipleAutocompleteValues = (valores, lista) => {
    if (valores) {
      return valores.map((valor) => value.autoComplete(lista, valor.id));
    }
    return [];
  };

  const retornoElemento = (id) => {
    const ref = document.getElementById(id);
    if (!ref) return;
    setTimeout(
      () =>
        ref.scrollIntoView({
          behavior: "smooth",
          block: "center",
        }),
      100,
    );
  };

  function obterValoresDoFormulario() {
    let formulario = document.getElementById("form");
    let elementosDoFormulario = formulario.elements;
    let valores = {};
    for (let i = 0; i < elementosDoFormulario.length; i++) {
      let elemento = elementosDoFormulario[i];
      if (elemento.type !== "submit") {
        valores[elemento.name] =
          elemento.value && elemento.value != "" ? elemento.value : undefined;
      }
    }
    return valores;
  }

  const handleAddActionsOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  return (
    <>
      <AddLayout
        id={id}
        formSubmit
        title={pessoa?.id ? "Editar pessoa" : "Cadastrar pessoa"}
        onClickSalvar={handleSubmit}
        loading={loading}
        userLog={id ? userLog : null}
        onClickLog={onClickLog}
        isFullscreenDialog={isFullscreenDialog}
        showUpdate={permissoesHelper.temPermisao("pessoas-editar")}
        actions={
          <div className="d-flex align-items-center justify-content-between gap-2">
            <FormControlLabel
              control={
                <Switch
                  checked={pessoa.ativado ?? false}
                  onChange={() =>
                    setPessoa((prevState) => ({
                      ...prevState,
                      ativado: !pessoa?.ativado,
                    }))
                  }
                  inputProps={{ "aria-label": "controlled" }}
                  name="ativado"
                  color="primary"
                />
              }
              label={pessoa?.ativado ? "Ativado" : "Desativado"}
            />
            {pessoa?.id && (
              <Button
                aria-label="add action conta receber"
                aria-controls={menuId}
                aria-haspopup="true"
                aria-expanded={isMenuOpen ? "true" : "false"}
                onClick={handleAddActionsOpen}
                color="inherit"
                style={{
                  borderRadius: 5,
                  backgroundColor: "#E5E5E5",
                }}
              >
                <span style={{ fontSize: 10 }}>mais ações</span>
              </Button>
            )}
          </div>
        }
        // formState={{
        //   inicial: prevStateRef?.current,
        //   final: montaObjetoPessoa(pessoa),
        // }}
      >
        {(!id || Object.keys(pessoa).length > 0) && (
          <Form onSubmit={handleSubmit}>
            <Grid className="grid-container">
              <Grid container spacing={2}>
                {id && (
                  <Grid item xs={2}>
                    <TextField
                      id="codigo"
                      name="codigo"
                      label="Código"
                      disabled
                      variant="outlined"
                      value={pessoa.codigo ? pessoa.codigo : ""}
                      fullWidth
                    />
                  </Grid>
                )}
                <Grid item xs={id ? 3 : 4}>
                  <Select
                    label="Natureza Social"
                    name="naturezaSocial"
                    id="naturezaSocial"
                    variant="outlined"
                    disabled={id}
                    onChange={(e) => handleInputChange(e)}
                    value={value.text(pessoa.naturezaSocial)}
                    InputLabelProps={{ shrink: true }}
                    error={inputErros.get("naturezaSocial")}
                    required
                  >
                    <MenuItem value={"fisica"}>Física</MenuItem>
                    <MenuItem value={"juridica"}>Jurídica</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={id ? 7 : 8}>
                  <TextField
                    label={
                      pessoa.naturezaSocial === "juridica"
                        ? "Razão Social"
                        : "Nome"
                    }
                    name="nomeRazaoSocial"
                    id="nomeRazaoSocial"
                    variant="outlined"
                    onChange={(e) => handleInputChange(e)}
                    fullWidth
                    obj={pessoa}
                    value={pessoa?.nomeRazaoSocial}
                    error={inputErros.get("nomeRazaoSocial")}
                    required
                  />
                </Grid>
                <Grid item xs={pessoa.naturezaSocial === "juridica" ? 8 : 3}>
                  <TextField
                    label={
                      pessoa.naturezaSocial === "juridica"
                        ? "Nome Fantasia"
                        : "Apelido"
                    }
                    name="apelidoFantasia"
                    id="apelidoFantasia"
                    variant="outlined"
                    fullWidth
                    onChange={(event) => handleInputChange(event, 20)}
                    InputLabelProps={{ shrink: true }}
                    error={
                      pessoa.naturezaSocial === "juridica"
                        ? inputErros.get("apelidoFantasia")
                        : false
                    }
                    value={pessoa?.apelidoFantasia}
                  />
                </Grid>
                <Grid item xs={pessoa.naturezaSocial === "juridica" ? 4 : 2}>
                  <DatePicker
                    id={
                      pessoa.naturezaSocial === "juridica"
                        ? "dataAbertura"
                        : "dataNascimento"
                    }
                    label={
                      pessoa.naturezaSocial === "juridica"
                        ? "Data de Abertura"
                        : "Data de Nascimento"
                    }
                    name={
                      pessoa.naturezaSocial === "juridica"
                        ? "dataAbertura"
                        : "dataNascimento"
                    }
                    minDate={new Date(1900, 1, 1)}
                    maxDate={new Date()}
                    format="dd/MM/yyyy"
                    onChange={(date) => {
                      if (pessoa.naturezaSocial === "juridica") {
                        handleDateChange("dataAbertura", date);
                      } else {
                        handleDateChange("dataNascimento", date);
                      }
                    }}
                    value={
                      pessoa.naturezaSocial === "juridica"
                        ? pessoa.dataAbertura
                          ? pessoa.dataAbertura
                          : null
                        : pessoa.dataNascimento
                        ? pessoa.dataNascimento
                        : null
                    }
                    setError={setInputErro}
                    error={
                      pessoa.naturezaSocial === "fisica"
                        ? inputErros.get("dataNascimento")
                        : false
                    }
                  />
                </Grid>
                {pessoa.naturezaSocial !== "juridica" && (
                  <Grid item xs={2}>
                    <Select
                      label="Sexo"
                      name="sexo"
                      id="sexo"
                      variant="outlined"
                      onChange={(e) => handleInputChange(e)}
                      value={value.text(pessoa.sexo)}
                      InputLabelProps={{ shrink: true }}
                      error={inputErros.get("sexo")}
                    >
                      <MenuItem value={"masculino"}>Masculino</MenuItem>
                      <MenuItem value={"feminino"}>Feminino</MenuItem>
                    </Select>
                  </Grid>
                )}
                {pessoa.naturezaSocial !== "juridica" && (
                  <>
                    <Grid item xs={2.5}>
                      <TextField
                        label="Inscrição Estadual Rural - 1"
                        id="inscricaoEstadualRural"
                        name="inscricaoEstadualRural"
                        variant="outlined"
                        fullWidth
                        onChange={(e) => handleInputChange(e)}
                        value={pessoa?.inscricaoEstadualRural || ""}
                      />
                    </Grid>
                    <Grid item xs={2.5}>
                      <TextField
                        label="Inscrição Estadual Rural - 2"
                        id="inscricaoEstadualRural2"
                        name="inscricaoEstadualRural2"
                        variant="outlined"
                        disabled={!pessoa?.inscricaoEstadualRural}
                        fullWidth
                        onChange={(e) => handleInputChange(e)}
                        value={pessoa?.inscricaoEstadualRural2 || ""}
                      />
                    </Grid>
                  </>
                )}
                <Grid item xs={pessoa.naturezaSocial === "juridica" ? 3 : 4}>
                  <MaskedInput
                    id="cnpjCpf"
                    label={
                      pessoa.naturezaSocial === "juridica" ? "CNPJ" : "CPF"
                    }
                    name="cnpjCpf"
                    variant="outlined"
                    margin="none"
                    disabled={!!id && pessoa?.cnpjCpf}
                    required={obrigadoriedadeCnpjCpf}
                    mask={
                      pessoa.naturezaSocial === "juridica"
                        ? "**.***.***/****-99"
                        : "999.999.999-99"
                    }
                    value={pessoa?.cnpjCpf}
                    error={inputErros.get("cnpjCpf")}
                    InputLabelProps={{ shrink: true }}
                    sx={{
                      "& input": {
                        textTransform: "uppercase",
                      },
                    }}
                    InputProps={{
                      endAdornment: pessoa.naturezaSocial === "juridica" && (
                        <InputAdornment position="end">
                          <IconButton
                            disabled={!!id}
                            onClick={onClickPesquisarCpfCnpj}
                          >
                            <i
                              className="ph-bold ph-magnifying-glass"
                              style={{ color: "#494C62", fontSize: 18 }}
                            ></i>
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid
                  item
                  xs={3}
                  className={
                    pessoa.naturezaSocial === "juridica" ? "d-flex" : "d-none"
                  }
                >
                  <TextField
                    id="inscricaoEstadual"
                    label="Inscrição Estadual"
                    name="inscricaoEstadual"
                    variant="outlined"
                    fullWidth
                    value={pessoa?.inscricaoEstadual}
                    onChange={(e) => handleInputChange(e)}
                    InputLabelProps={{ shrink: true }}
                    error={inputErros.get("inscricaoEstadual")}
                  />
                </Grid>
                <Grid
                  item
                  xs={3}
                  className={
                    pessoa.naturezaSocial === "juridica" ? "d-flex" : "d-none"
                  }
                >
                  <TextField
                    id="inscricaoEstadual2"
                    label="Inscrição Estadual - 2"
                    name="inscricaoEstadual2"
                    variant="outlined"
                    fullWidth
                    value={pessoa?.inscricaoEstadual2}
                    disabled={!pessoa?.inscricaoEstadual}
                    onChange={(e) => handleInputChange(e)}
                    InputLabelProps={{ shrink: true }}
                    error={inputErros.get("inscricaoEstadual2")}
                  />
                </Grid>
                <Grid
                  item
                  xs={4}
                  className={
                    pessoa.naturezaSocial !== "juridica" ? "d-flex" : "d-none"
                  }
                >
                  <TextField
                    id="rg"
                    label="RG"
                    name="rg"
                    variant="outlined"
                    fullWidth
                    value={pessoa?.rg}
                    onChange={(event) => handleInputChange(event)}
                    InputLabelProps={{ shrink: true }}
                    error={false}
                  />
                </Grid>
                <Grid item xs={pessoa?.naturezaSocial === "juridica" ? 3 : 4}>
                  <TextField
                    id="contato"
                    label="Contato"
                    name="contato"
                    variant="outlined"
                    value={pessoa?.contato}
                    onChange={(event) => handleInputChange(event, 35)}
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    label="E-mail"
                    name="email"
                    id="email"
                    type="email"
                    variant="outlined"
                    error={inputErros.get("email")}
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) => handleInputChange(e)}
                    value={pessoa?.email}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={4}>
                  <MaskedInput
                    id="telefone"
                    label="Telefone"
                    name="telefone"
                    margin="none"
                    error={inputErros.get("telefone")}
                    value={pessoa?.telefone}
                    mask="(99) 9999-9999"
                    onChange={(e) => handleInputChange(e)}
                    InputLabelProps={{ shrink: true }}
                    InputProps={{
                      endAdornment: (
                        <IconButton disabled={true}>
                          <i
                            className="ph-fill ph-phone"
                            style={{
                              color: "#494C62",
                              fontSize: 20,
                            }}
                          ></i>
                        </IconButton>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <MaskedInput
                    id="celular"
                    label="Celular"
                    name="celular"
                    margin="none"
                    value={value.text(pessoa.celular)}
                    error={inputErros.get("celular")}
                    mask="(99) 9 9999-9999"
                    onChange={(e) => handleInputChange(e)}
                    InputLabelProps={{ shrink: true }}
                    InputProps={{
                      endAdornment: (
                        <IconButton disabled={true}>
                          <i
                            className="ph-fill ph-device-mobile"
                            style={{
                              color: "#494C62",
                              fontSize: 20,
                            }}
                          ></i>
                        </IconButton>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Autocomplete
                    id="segmentoId"
                    name="segmentoId"
                    options={listaSegmentos}
                    noOptionsText="Sem opções"
                    autoHighlight
                    getOptionLabel={(option) => {
                      return option ? option.descricao : "";
                    }}
                    onChange={(_, newValue) => {
                      setPessoa((prevState) => ({
                        ...prevState,
                        segmentoId: newValue?.id ?? null,
                      }));
                    }}
                    value={listaSegmentos.find(
                      (item) => item?.id === pessoa?.segmentoId,
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Segmento"
                        error={inputErros.get("segmentoId")}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Autocomplete
                    id="rotasPessoa"
                    name="rotasPessoa"
                    options={listaRotas}
                    noOptionsText="Sem opções"
                    autoHighlight
                    getOptionLabel={(option) => {
                      return option ? option.descricao : "";
                    }}
                    onChange={(_, newValue) => {
                      setPessoa((prevState) => ({
                        ...prevState,
                        rotaId: newValue?.id ?? null,
                      }));
                    }}
                    value={listaRotas.find(
                      (item) => item?.id === pessoa?.rotaId,
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Rota"
                        error={inputErros.get("rotasPessoa")}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    id="inscricaoSuframa"
                    name="inscricaoSuframa"
                    label="Inscrição Suframa"
                    variant="outlined"
                    value={
                      pessoa?.inscricaoSuframa ? pessoa.inscricaoSuframa : ""
                    }
                    onChange={(e) => handleInputChange(e)}
                    inputProps={{ maxLength: 9 }}
                    fullWidth
                    error={inputErros.get("inscricaoSuframa")}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Autocomplete
                    multiple
                    id="tagsPessoa"
                    name="tagsPessoa"
                    options={listaTags}
                    noOptionsText="Sem opções"
                    autoHighlight
                    renderOption={(props, option) => {
                      return option ? (
                        <li {...props}>
                          <div className="d-flex align-items-center gap-2 w-100">
                            <i
                              className="ph-fill ph-bookmark-simple"
                              style={{ color: option.cor, fontSize: 18 }}
                            />
                            <div>{option.descricao}</div>
                          </div>
                        </li>
                      ) : (
                        ""
                      );
                    }}
                    getOptionLabel={(option) => {
                      return option ? option.descricao : "";
                    }}
                    onChange={(_, newValue) => {
                      setPessoa({
                        ...pessoa,
                        tagsPessoa: newValue,
                      });
                    }}
                    value={getMultipleAutocompleteValues(
                      pessoa?.tagsPessoa,
                      listaTags,
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Tags"
                        error={inputErros.get("tagsPessoa")}
                      />
                    )}
                  />
                </Grid>
              </Grid>
              <input
                accept="image/*"
                className="logo-image-input"
                ref={imageUpload}
                type="file"
                onChange={(event) => handleAvatarChange(event)}
              />
              <Box
                position="relative"
                sx={{
                  width: "100%",
                  maxWidth: "200px",
                  mx: "2em",
                  borderRadius: "3px",
                  overflow: "hidden",
                }}
              >
                <img
                  className="media"
                  src={pessoa.avatar ?? notFoundImage}
                  alt="avatar"
                />
                <Box
                  position="absolute"
                  top={8}
                  right={8}
                  display="flex"
                  flexDirection="column"
                  gap={1}
                >
                  <Tooltip title="Adicionar imagem" arrow placement="top">
                    <IconButton
                      size="small"
                      onClick={handleAddImage}
                      sx={{
                        backgroundColor: "#EDEEF0",
                        "&:hover": { backgroundColor: "#B6BABC" },
                        fontSize: "14px",
                      }}
                    >
                      <i className="ph-bold ph-upload-simple" />
                    </IconButton>
                  </Tooltip>
                  {pessoa.avatar && (
                    <>
                      <Tooltip title="Recortar" arrow placement="top">
                        <IconButton
                          size="small"
                          onClick={handleEditImage}
                          sx={{
                            backgroundColor: "#EDEEF0",
                            "&:hover": { backgroundColor: "#B6BABC" },
                            fontSize: "14px",
                          }}
                        >
                          <i className="ph ph-scissors" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Excluir" arrow placement="top">
                        <IconButton
                          size="small"
                          onClick={handleRemoveImage}
                          sx={{
                            backgroundColor: "#EDEEF0",
                            "&:hover": { backgroundColor: "#B6BABC" },
                            fontSize: "14px",
                          }}
                        >
                          <i className="ph-fill ph-trash" />
                        </IconButton>
                      </Tooltip>
                    </>
                  )}
                </Box>
              </Box>
              {isCropping && (
                <ImageCropper
                  image={imageAvatar}
                  open={isCropping}
                  onSave={(croppedFile) => onSaveImageClopper(croppedFile)}
                  onHide={() => onHideImageCropper()}
                />
              )}
            </Grid>
            <Grid className="grid-container">
              <Grid container spacing={2}>
                <Grid item xs={12} className="mt-4">
                  <span className="fw-bold fw-bolder">OBSERVAÇÃO</span>
                </Grid>
                <Grid item xs={12}>
                  <TextareaAutosize
                    id="observacao"
                    label="Observacao"
                    name="observacao"
                    variant="outlined"
                    maxLength={255}
                    value={pessoa?.observacao}
                    className="textRolagem bg-transparent"
                    onChange={(e) => handleInputChange(e)}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Button id="form-button" type="submit" className="d-none" />
          </Form>
        )}
        <div>
          <hr className="mt-5" />
          <div className="mt-4">
            <Enderecos
              permisoes={permisoes}
              id={id}
              pessoa={pessoa}
              enderecosLista={enderecosLista}
              setEnderecosLista={setEnderecosLista}
              openEndereco={openEndereco}
              setOpenEndereco={setOpenEndereco}
              inputErros={inputErrosEnderecos}
              cacheDto={cacheDto}
              setCacheDto={setCacheDto}
            />
          </div>
          <hr className="my-4" />
          <Grid item xs={12} className="mb-4">
            <span className="fw-bold fw-bolder">TIPOS DE PESSOA</span>
          </Grid>
          <Grid item xs={12}>
            <Autocomplete
              multiple
              id="tiposPessoas"
              name="tiposPessoas"
              options={listaTiposPessoa}
              noOptionsText="Sem opções"
              autoHighlight
              getOptionLabel={(option) =>
                option.descricao ? option.descricao : ""
              }
              onChange={(_, newValue) => {
                handleChangeTiposPessoas(newValue);
              }}
              value={getMultipleAutocompleteValues(
                pessoa?.tiposPessoas,
                listaTiposPessoa,
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="Tipos de Pessoa"
                  required
                  error={inputErros.get("tiposPessoas")}
                />
              )}
            />
          </Grid>
          <div className="mt-4">
            <TipoPessoas
              id={id}
              pessoa={pessoa}
              abaValue={abaValue}
              setAbaValue={setAbaValue}
              clienteFormRef={clienteFormRef}
              cliente={cliente}
              setCliente={setCliente}
              fornecedorFormRef={fornecedorFormRef}
              fornecedor={fornecedor}
              setFornecedor={setFornecedor}
              transportadoraFormRef={transportadoraFormRef}
              transportadora={transportadora}
              setTransportadora={setTransportadora}
              colaboradorFormRef={colaboradorFormRef}
              colaborador={colaborador}
              setColaborador={setColaborador}
              prestadorServicoFormRef={prestadorServicoFormRef}
              prestadorServico={prestadorServico}
              setPrestadorServico={setPrestadorServico}
              profissionalFormRef={profissionalFormRef}
              profissional={profissional}
              setProfissional={setProfissional}
              inputErros={inputErros}
              cacheDto={cacheDto}
              setCacheDto={setCacheDto}
            />
          </div>
        </div>
        <MenuAddActions
          anchorEl={anchorEl}
          setAnchorEl={setAnchorEl}
          pessoa={pessoa}
        />
      </AddLayout>
    </>
  );
};

export default AddPessoas;
